<template>
    <el-dialog
        :title="$t('message.repair.title')"
        :visible="dialogVisible"
        @close="handleClose"
        width="45%"
        class="address_dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <repair-form
            :repair-detail="repair_detail">
        </repair-form>
        <template #footer>
            <!-- <div>
                <el-button
                    type="primary"
                    @click="handleModify">
                    <span>{{$t("public.confirmBtn")}}</span>
                </el-button>
                <el-button
                    @click="handleClose">
                    <span>{{$t("public.cancelBtn")}}</span>
                </el-button>
            </div> -->
        </template>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    computed: mapState({
        dialogVisible: state => state.dialogVisible,
        repair_detail: state => state.other.repair_detail,
    }),
    components: {
        repairForm: () => import("@/components/service/repairForm"),
    },
    methods: {
        ...mapMutations([
            "handleDialog"
        ]),
        handleClose(){ // 关闭模态框
            this.handleDialog(false);
        },
    },
}
</script>

<style scoped>
</style>
